'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconTwoSquaresInBrackets, iconTwoSquaresInBracketsTag } from '@ni/nimble-components/dist/esm/icons/two-squares-in-brackets';
import { wrap } from '../../utilities/react-wrapper';

export type { IconTwoSquaresInBrackets };
export { iconTwoSquaresInBracketsTag };
export const NimbleIconTwoSquaresInBrackets = wrap(IconTwoSquaresInBrackets);